











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddTeamMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NewTeamForm_teams"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingsDashActiveMeetings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Team_team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AddTeamPayload",
  "abstractKey": null
};

(node ).hash = "2be35b227a34a62b0b0c74a206add6cf";

export default node;
